export default __webpack_public_path__ + "static/media/Rick_and_Morty_-_logo_(English).de13d484.png";